import { combineReducers, Reducer } from 'redux'
import { StateType } from 'typesafe-actions'
import type { AdminModuleSlice } from './Admin/store'
import { advisoryModuleReducer, advisoryModuleSagas } from './Advisory'
import {
  compliancereducer,
  IComplianceModuleState
} from './Compliance/store/reducers'
import { sagas as complianceSagas } from './Compliance/store/sagas'
import { feesReducer, IFeesState } from './Fees/store/reducer'
import { sagas as feeModuleSagas } from './Fees/store/sagas'
import { householdsReducer, householdSagas } from './Households/store'
import { performanceReducer } from './Operations/modules/Performance/store/reducer'
import { sagas as performanceSagas } from './Operations/modules/Performance/store/sagas'
import { IPaymentModuleState, paymentreducer } from './Payments/store/reducers'
import { sagas as paymentsSagas } from './Payments/store/sagas'
import { philanthropyReducer, philanthropySagas } from './Philanthropy'
import { IProductModuleState, productReducer } from './Products/store/reducers'
import { sagas as productSagas } from './Products/store/sagas'
import { IReportModuleState, reportreducer } from './Reports/store/reducer'
import { sagas as reportSagas } from './Reports/store/sagas'
import {
  overridesReducer,
  overridesSagas
} from './Security/features/Overrides/store'
import type { TeamsModuleSlice } from './Teams/store'
import {
  ITransferModuleState,
  transferReducer
} from './Transfers/store/reducers'
import { sagas as transfersSagas } from './Transfers/store/sagas'

import { ITrustModuleState, trustreducer } from './Trusts/store/reducers'
import { sagas as trustSagas } from './Trusts/store/sagas'

export const modulesSagas = [
  ...advisoryModuleSagas,
  ...paymentsSagas,
  ...transfersSagas,
  ...feeModuleSagas,
  ...philanthropySagas,
  ...trustSagas,
  ...householdSagas,
  ...reportSagas,
  ...complianceSagas,
  ...productSagas,
  ...overridesSagas,
  ...performanceSagas
]

interface IModulesState {
  advisory: ReturnType<typeof advisoryModuleReducer>
  fees: IFeesState
  payments: IPaymentModuleState
  transfers: ITransferModuleState
  philanthropy: StateType<typeof philanthropyReducer>
  trust: ITrustModuleState
  households: StateType<typeof householdsReducer>
  products: IProductModuleState
  reports: IReportModuleState
  compliance: IComplianceModuleState
  overrides: StateType<typeof overridesReducer>
  performance: StateType<typeof performanceReducer>
}

export type DynamicModulesState = AdminModuleSlice & TeamsModuleSlice
export type StaticModulesState = IModulesState

export const modulesReducer: Reducer<IModulesState> = combineReducers({
  advisory: advisoryModuleReducer,
  fees: feesReducer,
  payments: paymentreducer,
  transfers: transferReducer,
  philanthropy: philanthropyReducer,
  trust: trustreducer,
  households: householdsReducer,
  reports: reportreducer,
  compliance: compliancereducer,
  products: productReducer,
  overrides: overridesReducer,
  performance: performanceReducer
})
